<template>
	<tr>
		<slot></slot>
   </tr>
</template>
<script>
	export default {
		name: 'TableRow'
	}
</script>


// WEBPACK FOOTER //
// src/components/TableRow.vue